export default __webpack_public_path__ + "static/about-banner-d194726bfbee9ac254afacffd4f6fb81.png";